import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
  setAllCategories,
  setAllSpecialCategories,
} from "../../redux/actions/postActions";
import MyStorage from "../../common/MyStorage";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import RenderItem from "../../common/renderItem";
import ContentLoader from "react-content-loader";
import {
  KMTracking,
  campaignRecord,
} from "../../components/Tracking/KMTracking";
import InfiniteScroll from "react-infinite-scroll-component";
import Category from "../category/Category";
import _, { replace } from "lodash";
import cleanURL from "../../common/cleanURL";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import ProgressBar from "@ramonak/react-progress-bar";

const MyLoader = () => (
  <ContentLoader viewBox="0 0 1000 400">
    <rect x="3" y="20" rx="4" ry="4" width="200" height="200" />
    <rect x="250" y="20" rx="4" ry="4" width="200" height="200" />
    <rect x="500" y="20" rx="4" ry="4" width="200" height="200" />
    <rect x="750" y="20" rx="4" ry="4" width="200" height="200" />
    <rect x="750" y="240" rx="4" ry="4" width="120" height="28" />
    <rect x="750" y="280" rx="4" ry="4" width="173" height="29" />
    <rect x="750" y="321" rx="4" ry="4" width="200" height="31" />
    <rect x="3" y="240" rx="4" ry="4" width="120" height="28" />
    <rect x="250" y="240" rx="4" ry="4" width="120" height="28" />
    <rect x="500" y="240" rx="4" ry="4" width="120" height="28" />
    <rect x="3" y="280" rx="4" ry="4" width="175" height="28" />
    <rect x="3" y="321" rx="4" ry="4" width="131" height="33" />
    <rect x="250" y="280" rx="4" ry="4" width="200" height="29" />
    <rect x="250" y="321" rx="4" ry="4" width="116" height="30" />
    <rect x="500" y="280" rx="4" ry="4" width="173" height="29" />
    <rect x="500" y="321" rx="4" ry="4" width="200" height="31" />
  </ContentLoader>
);
const ImageLoader = (props) => (
  <ContentLoader
    speed={2}
    width={600}
    height={400}
    viewBox="0 0 600 400"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="-12" y="37" rx="0" ry="0" width="599" height="300" />
  </ContentLoader>
);

function SpecialCategories(props) {
  const sortOptions = [
    { id: 1, label: "Name", value: "name" },
    { id: 2, label: "Latest", value: "latest" },
    { id: 3, label: "Price Low to High", value: "price" },
    { id: 4, label: "Price High to Low", value: "-price" },
  ];

  const [cat_name, setCatName] = useState("");
  const [catID, setCatID] = useState("");
  const [productList, setProductList] = useState([]);
  const [sortBy, setSortBy] = useState<any>(sortOptions[0]);
  const [FromTheEditorText, setFromTheEditorText] = useState<any>({});
  const [trendingText, setTrendingText] = useState<any>("");
  const [is_loading, setIsLoading] = useState(true);
  const [category, setCategory] = useState<any>([]);
  const [featuredProductsID, setfeaturedProductsID] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [productCount, setProductCount] = useState(0);
  const [moreProductsAvailable, setMoreProductsAvailable] = useState(true);
  const [catBlurbs, setCatBlurbs] = useState<any>([]);
  const [cat_ID, setCat_ID] = useState(0);
  const [loader, setLoader] = useState(false);
  const [allProductListLength, setAllProductListLength] = useState("");
  const [allTrendingProductLength, setAllTrendingProductLength] = useState("");
  const [sortByClick, setSortByClick] = useState(false);
  const [DeliveryID,setDeliveryID]= useState("")
  var ACF;

  useEffect(() => {
    let ACFData:any = localStorage.getItem("ACF")
    let Deliveryid =JSON.parse(ACFData)?.FrasersDeliveryItemID
    setDeliveryID(Deliveryid)
    props.location.search &&
      campaignRecord(props.location.search, props.location.pathname);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    getSettings();
    console.log("here come data from------->", props?.match?.params);

    let catName = props?.match?.params?.cat_name.replace(/-/g, " ");
    catName = capitalizeFirstLetter(catName);
    let catID = props?.match?.params?.catID?.includes("?")
      ? props?.match?.params?.catID?.split("?")[0]
      : props?.match?.params?.catID;
    if (catName !== "") {
      if (catID?.includes("?")) {
        catID = catID.split("?");
        catID = catID[0];
      }
      setCatID(catID);
      if (catName?.toLowerCase().includes("trending")) {
        setPageNumber(1);
        getTrendingProducts(pageNumber);
        setCatName("Trending");
        getCategories(
          "trending",
          "0173ff9ad4cd4e2486cc11f83f5a046c-h2b295btag-trending"
        );
      } else if (
        catName?.toLowerCase().includes("featured") ||
        catName?.toLowerCase().includes("Featured Products") ||
        catName?.toLowerCase().includes("Featured Produts")
      ) {
        getCategories("featured", "4bbf67d9-989a-47e1-b32b-a4febde2432c");
        setPageNumber(1);
      } else {
        setPageNumber(1);
        getCategories(catName, catID);
      }
    }
  }, [sortBy, props?.match?.params?.cat_name, cat_name]);

  // replace from useEffect [sortBy, props?.match?.params?.cat_name, cat_name]

  const getFeatured = async (cat_id, pageNumber) => {
    let body = {
      Categories: [cat_id],
      Sort: sortBy?.value ? sortBy.value : "name",
      PageSize: 20,
      pageNumber: pageNumber ? pageNumber : 1,
    };
    let tempArr: any = [];
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getItemsByFilters(body, accessToken)
      .then((response) => {
        console.log(
          "response are come here inside featured========>",
          response
        );
        setAllProductListLength(response.TotalRecords);
        if (productCount == response.Records.length) {
          setProductCount(response.Records.length + 1);
          setLoader(false);
        } else {
          setProductCount(response.Records.length);
          setLoader(false);
        }
        if (response?.Records?.length > 0) {
          setProductCount(response?.Records?.length);
          response?.Records?.map((item) => {
            if (
              item?.ID == DeliveryID
            ) {
              return;
            } else {
              if (item) {
                tempArr = [...tempArr, item];
              }
            }
          });
          if (pageNumber == 1) {
            setProductList(tempArr);
            // let uniqueProducts: any = _.uniqBy(tempArr, "ID");
            setIsLoading(false);
          } else {
            setProductList(productList.concat(tempArr));
            setIsLoading(false);
          }
        } else {
          setMoreProductsAvailable(false);
          setIsLoading(false);
        }
      });
  };

  const getCategories = async (name, ID) => {
    let isSelected = 1;
    if (props?.allSpecialCategories?.length > 0) {
      props?.allSpecialCategories?.map((item) => {
        if (name?.toLowerCase() == "featured") {
          if (isSelected === 1) {
            if (
              item.Name.includes("Featured Products") ||
              item.Name.includes("Featured Produts")
            ) {
              isSelected = 2;
              getFeatured(item.ID, 1);
              setCategory(item);
              setCatName("Featured");
              setCat_ID(item.ID);
            }
          }
        } else if (item.ID == ID) {
          setCategory(item);
          setCatName(item?.Name);
          getFeatured(item.ID, 1);
          setCat_ID(item.ID);
        }
      });
    }
    // if (props?.allSpecialCategories?.length > 0) {
    //   let item = props?.allSpecialCategories?.find((item) => {
    //     return (
    //       item.Name.includes("Featured Products") ||
    //       item.Name.includes("Featured Produts")
    //     );
    //   });

    //   if (name?.toLowerCase() == "featured") {
    //     if (item) {
    //       getFeatured(item.ID, 1);
    //       setCategory(item);
    //       setCatName("Featured");
    //       setCat_ID(item.ID);
    //     }
    //   } else if (item.ID == ID) {
    //     setCategory(item);
    //     setCatName(item?.Name);
    //     getFeatured(item.ID, 1);
    //     setCat_ID(item.ID);
    //   }
    // }
    else {
      await new WebApiCalls().getAllCategoriesByHerarchy().then((response) => {
        if (response) {
          props?.setAllSpecialCategories(response);
          response?.map((item) => {
            if (name == "featured") {
              if (
                item.Name.includes("Featured Products") ||
                item.Name.includes("Featured Produts")
              ) {
                getFeatured(item.ID, 1);
                setCat_ID(item.ID);
                setCatName("Featured");
              }
            } else if (item.ID == ID) {
              setCategory(item);
              getFeatured(item.ID, 1);
              setCat_ID(item.ID);
              setCatName(item?.Name);
            }
          });
        }
      });
    }
  };
  const getTrendingProducts = async (pageNumber) => {
    if (!_.isEmpty(props?.acf)) {
      ACF = props?.acf;
    } else {
      await new WebApiCalls().getCustomFieldsCode(true).then((result) => {
        ACF = result;
        props.setACF(result);
      });
    }
    let customFieldQueries;
    if (ACF["Trending"] !== undefined) {
      customFieldQueries = [
        {
          Code: ACF["Trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    } else {
      customFieldQueries = [
        {
          Code: ACF["trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    }
    let tempArr: any = [];
    let itemObj = {
      CustomFieldQueries: customFieldQueries,
      Sort: sortBy?.value ? sortBy.value : "name",
      PageSize: 20,
      pageNumber: pageNumber ? pageNumber : 1,
    };
    //   let accessToken = localStorage.getItem('authenticationFrasers')
    const localStorage = new MyStorage();
    // this.setState({ cartSpinner: true });
    // let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("authenticationFrasers");
    await new WebApiCalls()
      .getItemsByFilters(itemObj, accessToken)
      .then((_response) => {
        setIsLoading(false);
        setMoreProductsAvailable(false);
        setAllProductListLength(_response.TotalRecords);
        if (_response?.Records?.length > 0) {
          setLoader(false);
          _response.Records.map((item) => {
            tempArr = [...tempArr, item];
          });
        } else {
          setLoader(false);
        }
        if (!sortByClick) {
          let uniqueProducts: any = _.uniqBy(tempArr, "ID");
          setProductList(productList.concat(uniqueProducts));
        } else {
          setProductList(tempArr);
          setSortByClick(false);
        }

        // tempArr = tempArr.filter((item) => {
        //   return item?.StockLimited && item?.StockQuantity > 0;
        // });
      });
  };

  // console.log("Props: ", props)
  const getSettings = async () => {
    let blurbs: any = [];
    await new WebApiCalls().getSettings().then((_response) => {
      if (_response.data) {
        if (_response.data.Items.length > 0) {
          _response.data.Items.map((item) => {
            item.item_name = item.item_name ? item.item_name : "";
            if (item.item_name.includes("featuredProducts")) {
              setFromTheEditorText(JSON.parse(item.item_detail));
            } else if (item.item_name.includes("trendingProducts")) {
              // console.log("item here:   ", JSON.parse(item.item_detail).blurb)
              setTrendingText(JSON.parse(item.item_detail).blurb);
            } else if (item.item_name.includes("CategoryBlurb")) {
              let item1 = JSON.parse(item?.item_detail);
              blurbs = [...blurbs, item1];
            }
          });
          setCatBlurbs(blurbs);
        }
      }
    });
  };

  const capitalizeFirstLetter = (string) => {
    return string.toString().charAt(0).toUpperCase() + string.slice(1);
  };
  const onClickItem = (_item) => {
    props?.history?.push(`/product/${cleanURL(_item.Name)}/${_item.ID}`, {
      from: "Special Categories",
    });
  };

  let selectedBlurb = "";
  if (cat_name?.toLowerCase()?.includes("featured")) {
    selectedBlurb = FromTheEditorText?.item_detail;
  } else if (catBlurbs?.length > 0) {
    catBlurbs?.map((cat, index) => {
      if (
        category?.ID === cat?.id ||
        category?.Name?.toLowerCase() === cat?.label?.toLowerCase() ||
        cat_name?.toLowerCase() == cat?.label?.toLowerCase() ||
        cat?.label?.toLowerCase() === cat_name?.toLowerCase()
      ) {
        selectedBlurb = cat.blurb;
      }
    });
  }
  return (
    <div>
      <Helmet>
        <meta
          property="og:title"
          content={
            cat_name?.toLowerCase()?.includes("featured")
              ? "From the Editor"
              : cat_name == "trending" || cat_name == "Trending"
              ? "Trending"
              : cat_name
          }
          data-rh="true"
        />
        <meta
          property="og:description"
          content={selectedBlurb}
          data-rh="true"
        />
        <meta
          property="og:image"
          content={
            cat_name == "trending" || cat_name == "Trending"
              ? "images/frasers_trending.jpg"
              : props?.match?.params?.cat_name == "featured"
              ? "images/featured-hero.jpg"
              : category?.Media?.length > 0
              ? category?.Media[0]?.MediaUrl
              : ""
          }
          data-rh="true"
        ></meta>
      </Helmet>
      <div className="viewport"></div>

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        <MenuBar
          props={props}
          categoriesArray={props?.allCategories ? props?.allCategories : []}
        />
        {/* /content */}
        <div className="content">
          {/*breadcrumb */}
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <a href="#">
              {cat_name?.toLowerCase()?.includes("featured")
                ? "From The Editor"
                : capitalizeFirstLetter(cat_name)}
            </a>
            {/* <a href="#">Wearables & Smart Home</a> */}
          </div>
          {/*/breadcrumb */}

          {/*category hero */}

          <div className="category-hero">
            {is_loading ? (
              <ImageLoader />
            ) : (
              <div className="thumb">
                <div className="overlay"></div>
                <img
                  src={
                    cat_name == "trending" || cat_name == "Trending"
                      ? "images/frasers_trending.jpg"
                      : props?.match?.params?.cat_name == "featured" ||
                        props?.match?.params?.cat_name == "featured-produts"
                      ? "images/featured-hero.jpg"
                      : category?.Media?.length > 0
                      ? category?.Media[0]?.MediaUrl
                      : ""
                  }
                />
              </div>
            )}
            <div className="text">
              <div className="title">
                {cat_name?.toLowerCase()?.includes("featured") ? (
                  <div>{FromTheEditorText?.title}</div>
                ) : cat_name == "trending" || cat_name == "Trending" ? (
                  "Trending"
                ) : (
                  cat_name
                )}
              </div>

              {cat_name?.toLowerCase()?.includes("trending") ? (
                <div className="sub">{trendingText ? trendingText : ""}</div>
              ) : cat_name?.toLowerCase()?.includes("featured") ? (
                <div className="sub">{FromTheEditorText?.blurb}</div>
              ) : (
                catBlurbs?.length > 0 &&
                catBlurbs?.map((cat, index) => {
                  if (
                    category?.ID === cat?.id ||
                    category?.Name?.toLowerCase() ===
                      cat?.label?.toLowerCase() ||
                    cat_name?.toLowerCase() == cat?.label?.toLowerCase() ||
                    cat?.label?.toLowerCase() === cat_name?.toLowerCase()
                  ) {
                    return (
                      <div key={index} className="sub">
                        {cat.blurb}
                      </div>
                    );
                  }
                })
              )}

              {/* "Your guide to the hottest products in home, beauty, fashion and tech." */}
            </div>
          </div>

          {/*/category hero */}

          {/*product listing */}
          <div className="product-listing">
            {/*filter */}
            <div className="filter full" style={{ marginBottom: 20 }}>
              <div className="text">Sort by</div>
              <select
                value={sortBy.value}
                name="sortby"
                id="sortby"
                onChange={(e: any) => {
                  setPageNumber(1);
                  setSortByClick(true);
                  setSortBy(
                    sortOptions.find((option) => option.value == e.target.value)
                  );
                }}
              >
                {sortOptions?.map((item: any, index) => {
                  return (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </div>
            {/*/filter */}

            {/*slide-categories */}
            <div className="slide-sortby">
              <div className="title">SORT BY</div>
              <a href="#">Name</a>
              <a href="#">Latest</a>
              <a href="#">Price (High)</a>
              <a href="#">Price (Low)</a>
            </div>
            {/*/slide-categories */}

            {/*two-columns */}
            <div className="products full">
              <div>
                {is_loading ? (
                  <MyLoader />
                ) : (
                  <>
                    {productList.length > 0 ? (
                      <div className="products" style={{ width: "100%" }}>
                        {productList?.map((item: any, index: number) => {
                          return (
                            <RenderItem
                              key={index}
                              is_slider={false}
                              item={item}
                              onClickItem={onClickItem}
                              from={"Special Categories"}
                            />
                          );
                        })}
                        <i aria-hidden={true}></i>
                        <i aria-hidden={true}></i>
                      </div>
                    ) : (
                      <div className="products">
                        <br />
                        There are currently no products in this category.
                        <br />
                        Please check again later.
                      </div>
                    )}
                    {productList.length > 0 && (
                      <div
                        style={{ textAlign: "center" }}
                        className="load-more-sec"
                      >
                        {/* <MyLoader /> */}
                        <div style={{ textAlign: "center" }}>
                          <div
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "11px",
                              lineHeight: "20px",
                              color: "#666",
                            }}
                          >
                            {`You've viewed ${productList.length} of ${allProductListLength}
                          products`}
                          </div>
                          <ProgressBar
                            className="progress-bar"
                            isLabelVisible={false}
                            maxCompleted={parseInt(allProductListLength)}
                            completed={productList.length}
                            height="2px"
                            width="100%"
                            bgColor="#000000"
                          />
                        </div>
                        {parseInt(allProductListLength) !==
                          productList.length && (
                          <div>
                            {!loader ? (
                              <button
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "12px",
                                  backgroundColor: "#ffffff",
                                  color: "#000000",
                                  padding: "10px 60px",
                                  border: "1px solid #DDDDDD",
                                  cursor: "pointer",
                                  letterSpacing: "1.5px",
                                  fontWeight: 500,
                                }}
                                className="btn"
                                onClick={() => {
                                  if (cat_name == "Featured") {
                                    let page = pageNumber + 1;
                                    setPageNumber(page);
                                    if (cat_ID !== 0) {
                                      getFeatured(cat_ID, page);
                                      setLoader(true);
                                    }
                                  } else if (cat_name == "Trending") {
                                    let page = pageNumber + 1;
                                    setPageNumber(page);
                                    getTrendingProducts(page);
                                    setLoader(true);
                                  } else {
                                    let page = pageNumber + 1;
                                    setPageNumber(page);
                                    if (cat_ID !== 0) {
                                      getFeatured(cat_ID, page);
                                      setLoader(true);
                                    }
                                  }
                                }}
                              >
                                LOAD MORE
                              </button>
                            ) : (
                              <SpinnerCircular
                                color="black"
                                size="33"
                                thickness={170}
                                speed={200}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            {/*/two-columns */}
          </div>
          {/*/product listing */}
        </div>
        {/* /content*/}
      </div>

      <Footer
        props={props}
        categoriesArray={props?.allCategories ? props?.allCategories : []}
      />
      <a onClick={() => window.scrollTo(0, 0)} className="btt">
        <img src="images/uparrow.svg" alt="" />
      </a>
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, acf, allCategories, allSpecialCategories } =
    state.UserReducer;
  return { cart_count, acf, allCategories, allSpecialCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
  setAllCategories,
  setAllSpecialCategories,
};
export default connect(mapStateToProps, actions)(SpecialCategories);
